// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2p9Mu","header":"MessagesList_header__2tIOr","chat":"MessagesList_chat__21LYf"};